import { Navigate } from "react-router-dom";
import ForgotPassword from "pages/Auth/ForgotPassword";
import Login from "pages/Auth/Login";
import Dashboard from "pages/Dashboard";
import Bookings from "pages/Bookings";
import Users from "pages/SuperAdmin/Users";
import Logout from "pages/Auth/Logout";
import Roles from "pages/SuperAdmin/Roles";
import AddEditRole from "pages/SuperAdmin/Roles/AddEditRole";
import AddEditUser from "pages/SuperAdmin/Users/AddEditUser";
import Customers from "pages/SuperAdmin/Customers";
import Settings from "pages/SuperAdmin/Settings";
import AppSettings from "pages/SuperAdmin/Settings/AppSettings";
import Addons from "pages/Membership/Addons";
import AddEditAddon from "pages/Membership/Addons/AddEditAddon";
import Vehicles from "pages/Vehicles";
import Plans from "pages/Membership/Plans";
import AddEditPlan from "pages/Membership/Plans/AddEditPlan";
import AddEditMake from "pages/Vehicles/Make/AddEditMake";
import VehicleMake from "pages/Vehicles/Make";
import VehicleModel from "pages/Vehicles/Model";
import AddEditVehicleModel from "pages/Vehicles/Model/AddEditVehicleModel";
import VehicleColor from "pages/Vehicles/Color";
import AddEditVehicleColor from "pages/Vehicles/Color/AddEditVehicleColor";
import VerifyInvite from "pages/Auth/VerifyInvite";
import FreeWashRules from "pages/Membership/FreeWash";
import PlanDetails from "pages/Membership/Plans/PlanDetails";
import AddonDetails from "pages/Membership/Addons/AddonDetails";
import CustomerDetails from "pages/SuperAdmin/Customers/Details/CustomerDetails";
import Branches from "pages/Branches";
import AddEditBranch from "pages/Branches/AddEditBranch";
import WashHistory from "pages/WashHistory";
import WashHistoryDetails from "pages/WashHistory/WashHistoryDetails";
import Banners from "pages/Banners";
import AddEditBanner from "pages/Banners/AddEditBanner";
import BannerDetails from "pages/Banners/BannerDetails";
import PushNotification from "pages/Notification/PushNotification";
import NotificationHistory from "pages/Notification/NotificationHistory";
import Rules from "pages/Notification/Rules";
import NotificationHistoryDetails from "pages/Notification/NotificationHistory/NotificationHistoryDetails";
import AddEditRule from "pages/Notification/Rules/AddEditRule";
import APILogs from "pages/APILogs";
import APILogDetails from "pages/APILogs/APILogDetails";
import RoleDetails from "pages/SuperAdmin/Roles/RoleDetails";
import Profile from "pages/Profile";
import BranchDetails from "pages/Branches/BranchDetails";
import UserDetails from "pages/SuperAdmin/Users/UserDetails";
import Coupons from "pages/Coupons";
import AddEditCoupon from "pages/Coupons/AddEditCoupon";
import PageContentEditor from "pages/SuperAdmin/Settings/PageContentEditor";
import AddEditStoreCamera from "pages/StoreCamera/AddEditStoreCamera";
import StoreCamera from "pages/StoreCamera";
import StoreCameraDetails from "pages/StoreCamera/StoreCameraDetails";
import ApplliedCouponsHistory from "pages/Coupons/ApplliedCouponsHistory";
import CouponDetails from "pages/Coupons/CouponDetails";
import ANPRLogs from "pages/ANPRLogs";
import AuditLogs from "pages/AuditLogs";
import BarrierControlLogs from "pages/BarrierControLogs";
import KioskActivity from "pages/KioskActivity";
import DynamicPrices from "pages/Membership/DynamicPrices";
import DynamicPricesList from "pages/Membership/DynamicPrices/DynamicPricesList";

const authProtectedRoutes = [
  // DASHBOARD
  { path: "/dashboards", element: <Dashboard />, module: "dasdhboard" },

  // BOOKINGS
  { path: "/bookings", element: <Bookings />, module: "bookings" },

  // USERS
  { path: "/users", element: <Users />, module: "users" },
  {
    path: "/users/add-user",
    element: <AddEditUser mode="add" />,
    module: "users",
  },
  {
    path: "/users/edit-user",
    element: <AddEditUser mode="edit" />,
    module: "users",
  },
  {
    path: "/users/user-details",
    element: <UserDetails />,
    module: "users",
  },
  // CUSTOMERS
  { path: "/customers", element: <Customers />, module: "customers" },
  {
    path: "/customers/customer-details",
    element: <CustomerDetails />,
    module: "customers",
  },

  //

  // VEHICLES
  { path: "/vehicles", element: <Vehicles />, module: "vehicles" },

  // VEHICLE MAKE
  {
    path: "/vehicles/make",
    element: <VehicleMake />,
    module: "vehicles",
  },
  {
    path: "/vehicles/make/add",
    element: <AddEditMake mode="add" />,
  },
  {
    path: "/vehicles/make/edit",
    element: <AddEditMake mode="edit" />,
  },
  // VEHICLE MODEL
  {
    path: "/vehicles/model",
    element: <VehicleModel />,
    module: "vehicles",
  },
  {
    path: "/vehicles/model/add",
    element: <AddEditVehicleModel mode="add" />,
  },
  {
    path: "/vehicles/model/edit",
    element: <AddEditVehicleModel mode="edit" />,
  },
  // VEHICLE COLOR
  {
    path: "/vehicles/color",
    element: <VehicleColor />,
    module: "vehicles",
  },
  {
    path: "/vehicles/color/add",
    element: <AddEditVehicleColor mode="add" />,
  },
  {
    path: "/vehicles/color/edit",
    element: <AddEditVehicleColor mode="edit" />,
  },

  // ROLES
  { path: "/roles", element: <Roles />, module: "roles" },
  {
    path: "/roles/add-role",
    element: <AddEditRole mode="add" />,
    module: "roles",
  },
  {
    path: "/roles/edit-role",
    element: <AddEditRole mode="edit" />,
    module: "roles",
  },
  {
    path: "/roles/role-details",
    element: <RoleDetails />,
    module: "roles",
  },

  // PAGE CONTENT
  {
    path: "/settings",
    element: <Settings />,
    module: "settings",
  },
  {
    path: "/settings/app-settings",
    element: <AppSettings />,
    module: "settings",
  },
  {
    path: "/settings/terms-and-condition",
    element: <PageContentEditor defaultType="TermsAndConditions" />,
    module: "settings",
  },
  {
    path: "/settings/privacy-policy",
    element: <PageContentEditor defaultType="PrivacyPolicy" />,
    module: "settings",
  },
  {
    path: "/settings/faq",
    element: <PageContentEditor defaultType="FAQ" />,
    module: "settings",
  },

  // MEMBERSHIP PLANS
  {
    path: "/membership/plans",
    element: <Plans />,
  },
  {
    path: "/membership/plans/add-plan",
    element: <AddEditPlan mode="add" />,
  },
  {
    path: "/membership/plans/edit-plan",
    element: <AddEditPlan mode="edit" />,
  },
  {
    path: "/membership/plans/plan-details",
    element: <PlanDetails />,
  },
  // ADDONS
  {
    path: "/membership/addons",
    element: <Addons />,
  },
  {
    path: "/membership/addons/add-addon",
    element: <AddEditAddon mode="add" />,
  },
  {
    path: "/membership/addons/edit-addon",
    element: <AddEditAddon mode="edit" />,
  },
  {
    path: "/membership/addons/addon-details",
    element: <AddonDetails />,
  },
  {
    path: "/dynamic-prices/list",
    element: <DynamicPricesList />,
  },
  {
    path: "/dynamic-prices/add",
    element: <DynamicPrices />,
  },
  {
    path: "/dynamic-prices/edit",
    element: <DynamicPrices mode={"edit"} />,
  },
  // NOTIFICATION
  {
    path: "/notification/push-notification",
    element: <PushNotification />,
  },
  {
    path: "/notifications/edit-notification",
    element: <PushNotification mode="edit" />,
  },
  {
    path: "/notification/history",
    element: <NotificationHistory />,
  },
  {
    path: "/notification/history/history-details",
    element: <NotificationHistoryDetails />,
  },
  {
    path: "/notification/rules",
    element: <Rules />,
  },
  {
    path: "/notification/rules/add-rule",
    element: <AddEditRule mode="add" />,
  },
  {
    path: "/notification/rules/edit-rule",
    element: <AddEditRule mode="edit" />,
  },

  // BRANCHES/STORES
  {
    path: "/stores",
    element: <Branches />,
  },
  {
    path: "/stores/add-store",
    element: <AddEditBranch mode="add" />,
  },
  {
    path: "/stores/edit-store",
    element: <AddEditBranch mode="edit" />,
  },
  {
    path: "/stores/store-details",
    element: <BranchDetails />,
  },
  // WASH HISTORY
  {
    path: "/wash-history",
    element: <WashHistory />,
  },
  {
    path: "/wash-history/wash-history-details",
    element: <WashHistoryDetails />,
  },

  // BANNERS
  {
    path: "/banners",
    element: <Banners />,
  },
  {
    path: "/banners/add-banner",
    element: <AddEditBanner mode="add" />,
  },
  {
    path: "/banners/edit-banner",
    element: <AddEditBanner mode="edit" />,
  },
  {
    path: "/banners/banner-details",
    element: <BannerDetails />,
  },

  { path: "/logout", element: <Logout /> },
  { path: "*", element: <Navigate to="/dashboards" replace /> },

  // API LOGS
  { path: "/api-logs", element: <APILogs />, module: "api_logs" },
  {
    path: "/api-logs/api-logs-details",
    element: <APILogDetails />,
    module: "api_logs",
  },
  // Admin Profile
  { path: "/profile", element: <Profile /> },
  // ANPR Logs
  { path: "/anpr-logs", element: <ANPRLogs /> },
  // Audit Logs
  { path: "/audit-logs", element: <AuditLogs /> },
  // Barrier Control Logs
  { path: "/barrier-control-logs", element: <BarrierControlLogs /> },
  // Kiosk Activities
  { path: "/pos-activities", element: <KioskActivity /> },

  // COUPONS
  { path: "/coupons", element: <Coupons /> },
  { path: "/coupons/add-coupon", element: <AddEditCoupon mode="add" /> },
  { path: "/coupons/edit-coupon", element: <AddEditCoupon mode="edit" /> },
  { path: "/coupons/applied-coupons", element: <ApplliedCouponsHistory  /> },
  { path: "/coupons/coupon-details", element: <CouponDetails  /> },
  // STORE CAMERAS
  { path: "/store-cameras", element: <StoreCamera /> },
  { path: "/store-cameras/add", element: <AddEditStoreCamera mode="add" /> },
  { path: "/store-cameras/edit", element: <AddEditStoreCamera mode="edit" /> },
  { path: "/store-cameras/details", element: <StoreCameraDetails  /> },
];

const publicRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/verify-invite", element: <VerifyInvite /> },
];

export { authProtectedRoutes, publicRoutes };
